import { Injectable } from '@angular/core';
import { environment } from '@app/environment';
import { CategoryViewModel, LanguageViewModel, QuestionsService, TranslationService } from '@app/shared/rest-api';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, publishReplay, refCount, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UmbracoService {
  private languages$: Observable<LanguageViewModel[]>;
  public languageChanged$: BehaviorSubject<string> = new BehaviorSubject(environment.defaultLanguage);

  public topics$: BehaviorSubject<CategoryViewModel[]> = new BehaviorSubject([]);
  public translations$: BehaviorSubject<{ [key: string]: string }> = new BehaviorSubject(null);

  constructor(
    private translationService: TranslationService,
    private questionsService: QuestionsService,
  ) {
    this.getLanguages();

    this.languageChanged$.pipe(
      debounceTime(50),
      distinctUntilChanged(),
      switchMap(lang => forkJoin([
        this.getTopics(lang),
        this.getTranslations(lang)
      ]))
    ).subscribe(([topics, translations]) => {
      this.topics$.next(topics);
      this.translations$.next(translations);
    });
  }

  public getLanguages() {
    if (!this.languages$) {
      this.languages$ = this.translationService.apiLanguagesGet().pipe(
        publishReplay(1),
        refCount()
      );
    }

    return this.languages$;
  }

  private getTranslations(lang: string) {
    return this.translationService.apiTranslationsGet('challengeu', lang);
  }

  private getTopics(lang: string) {
    return this.questionsService.apiQuestionsRepositoryCategoriesGet('challengeu', lang);
  }

  public setLanguage(lang: string) {
    this.languageChanged$.next(lang);
  }
}
